import { render } from "./PersonalBillingAccountListItem.vue?vue&type=template&id=124453b2&scoped=true"
import script from "./PersonalBillingAccountListItem.vue?vue&type=script&lang=js"
export * from "./PersonalBillingAccountListItem.vue?vue&type=script&lang=js"

import "./PersonalBillingAccountListItem.vue?vue&type=style&index=0&id=124453b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-124453b2"]])

export default __exports__